





































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import JobsearchRecruiterSearchBox from "@/components/jobsearch/JobsearchRecruiterSearchBox.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { PORTAL_STAFF_ROLE } from "@/consts/portal";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";

@Component({
  components: {
    AppTextField,
    JobsearchRecruiterSearchBox,
    AppAuthButton,
  },
})
export default class PortalStaffAgentLogin extends Mixins(
  AxiosMixin,
  UtilMixin
) {
  private searchKey = ""; //絞り込み文字列

  private items = [];

  private PORTAL_STAFF_ROLE = PORTAL_STAFF_ROLE;

  private headers = [
    { text: "選択", value: "action" },
    { text: "システムID", value: "system_id" },
    { text: "スタッフ名", value: "staff_name" },
    { text: "事業所名", value: "portal_office.name" },
    { text: "権限", value: "role" },
  ];

  //データ取得
  private fetchList(searchObj: unknown): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/jobsearch_recruiters/get_with_office",
      searchObj,
      (res) => {
        this.items = res.data.jobsearch_recruiters ?? [];
      }
    );
  }

  //代理ログイン
  private login(id: number) {
    this.postJsonCheck(
      window.base_url +
        "/api/admin/portallogin/jobsearch-recruiter-agent-login",
      {
        recruiter_id: id,
      },
      (res) => {
        window.open(
          window.kaedoki_url +
            "/job-posting/signin?token=" +
            res.data.onetime_token,
          "_blank"
        );
      }
    );
  }
}
